var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalsCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.55 22.5 13 18.95l1.4-1.4 2.125 2.125 4.25-4.25 1.4 1.425-5.625 5.65ZM7.4 17 6 15.6 7.6 14 6 12.4 7.4 11 9 12.6l1.6-1.6 1.4 1.4-1.6 1.6 1.6 1.6-1.4 1.4L9 15.4 7.4 17ZM5 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 20V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 5 4h1V2h2v2h8V2h2v2h1c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v6.35l-2 2.025V10H5v10h6.25l1.975 2H5ZM5 8h14V6H5v2Z",
    fill: "#2F42C2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalsCalendar);
export default __webpack_public_path__ + "static/media/goals_calendar.861c62cd2d110008ff8093a091835e3d.svg";
export { ForwardRef as ReactComponent };